
import React from 'react';
import PropTypes from 'prop-types';

const InstructionsIcon = ({ className }) => {
  return (
    <svg 
      width="26" 
      height="25" 
      viewBox="0 0 26 25" 
      fill="none"
      className={`fill-current ${className}`}
      xmlns="http://www.w3.org/2000/svg">
        <path d="M6.96212 10.0611C6.57397 9.20852 6.36546 8.28518 6.34961 7.34856C6.5338 5.77213 7.29055 4.31826 8.47617 3.2631C9.6618 2.20794 11.1937 1.625 12.7808 1.625C14.368 1.625 15.8999 2.20794 17.0855 3.2631C18.2711 4.31826 19.0279 5.77213 19.2121 7.34856C19.1868 8.28402 18.9787 9.2055 18.5996 10.0611" stroke="currentColor" fill="transparent" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M6.00002 17.4982C4.5247 17.2312 3.1903 16.4538 2.23048 15.302C1.27066 14.1502 0.74659 12.6975 0.750017 11.1982C0.750017 7.69824 3.11253 5.51074 6.61253 5.51074" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="transparent"/>
        <path d="M18.8623 5.51074C22.4498 5.51074 24.8123 7.69824 24.8123 11.1982C24.8157 12.6975 24.2917 14.1502 23.3318 15.302C22.372 16.4538 21.0376 17.2312 19.5623 17.4982" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="transparent"/>
        <path d="M6 17.499V24.149H19.475V17.499" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="transparent"/>
        <path d="M6 20.8232H19.475" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="transparent"/>
        <path d="M12.7373 20.8232V17.3232" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="transparent"/>
    </svg>
  );
};

InstructionsIcon.propTypes = {
  className: PropTypes.string, // Optional: allows passing Tailwind or custom classes
};

InstructionsIcon.defaultProps = {
  className: '', // Default to an empty string
};

export default InstructionsIcon;